export type TaskDirection = 'inbound' | 'outbound';
export type TaskType = 'voice' | 'text';

export enum TaskState {
  Pending = 'PENDING',
  Offered = 'OFFERED',
  Rejected = 'REJECTED',
  Abandoned = 'ABANDONED',
  Accepted = 'ACCEPTED',
  WrapUp = 'WRAPUP',
  Completed = 'COMPLETED',
  TimedOut = 'TIMEDOUT',
}

export interface TaskOptions {
  id: string;
  tenantId?: string;
  from: string;
  to?: string;
  startedAt?: number;
  type?: TaskType;
  direction?: TaskDirection;
  state?: TaskState;
  displayName?: string;
  attributes?: Record<string, any>;
  wrapUpStartedAt?: number | null;
  wrapUpEndsAt?: number | null;
  queueName?: string;
  queueId?: string;
  isInternal?: boolean;
}

export type CreateTaskOptions = TaskOptions;

export interface ITask {
  readonly id: string;
  readonly state: TaskState;
  readonly startedAt: Date;
  readonly type: TaskType;
  readonly direction: TaskDirection;
  readonly from: string;
  readonly to?: string;
  readonly tenantId?: string;
  readonly displayName: string;
  readonly attributes: Record<string, any>;
  readonly wrapUpStartedAt: number | null;
  readonly wrapUpEndsAt: number | null;
  readonly queueName: string | undefined;
  readonly isInternal: boolean;
  readonly loading: boolean;
}
